import { SanityPullQuoteSection } from "@sourceful/shared-types";
import { styled } from "@sourceful/shared-components";
import { PageSectionWrapper } from "../BasePageSection";
import { getSanityImgUrl } from "@lib/sanity";
import toRem from "@styles/postprocess/conversion/to-rem";

const Wrapper = styled("div", {
  maxWidth: "1200px",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingLeft: "clamp(50px, 10vw, 90px)",
  paddingRight: "clamp(50px, 10vw, 90px)",
  paddingTop: "clamp(95px, 10vw, 110px)",
  paddingBottom: "clamp(95px, 10vw, 110px)",
});

const Quote = styled("blockquote", {
  fontSize: "$h4",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  padding: "0px",
  margin: "0px",
  quotes: '"“" "”"',
  lineHeight: "clamp(26.25px, 3vw, 37.5px)",
  "&::before": {
    content: "open-quote",
  },
  "&::after": {
    content: "close-quote",
  },
});

const AttributionWrapper = styled("div", {
  display: "grid",
  gridTemplateColumns: "repeat(2, max-content)",
  gridGap: toRem(10),
  marginTop: "clamp(15px, 3vw, 38px)",
  alignItems: "center",
});

const Attribution = styled("div", {
  fontSize: "14px",
  variants: {
    jobDescription: {
      true: {
        fontSize: "12px",
        opacity: "0.8",
      },
    },
  },
});

const ImageWrapper = styled("div", {
  borderRadius: "$round",
  height: toRem(40),
  width: toRem(40),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const StyledImage = styled("img", {
  borderRadius: "$round",
});

export interface PullQuoteSectionProps {
  section: SanityPullQuoteSection;
}

const PullQuoteSection = ({ section }: PullQuoteSectionProps) => {
  const {
    quote,
    textColour,
    backgroundColour,
    image,
    attributedTo,
    attributedToDescription,
    _key,
  } = section;

  return (
    <PageSectionWrapper
      css={{ padding: "0px", backgroundColor: backgroundColour?.value, minHeight: 0 }}
      id={`s${_key}`}
      aria-labelledby={`sh${_key}`}
    >
      <Wrapper>
        <Quote css={{ color: textColour?.value }}>{quote}</Quote>
        <AttributionWrapper>
          {image && (
            <ImageWrapper>
              <StyledImage
                src={getSanityImgUrl(image?.asset._ref || "", base => base.width(40).height(40))}
                alt={
                  attributedTo + (attributedToDescription ? ` - ${attributedToDescription}` : "")
                }
                height={40}
                width={40}
              />
            </ImageWrapper>
          )}
          <div>
            <Attribution css={{ color: textColour?.value, textAlign: image ? "left" : "center" }}>
              {attributedTo}
            </Attribution>
            {attributedToDescription && (
              <Attribution
                css={{ color: textColour?.value, textAlign: image ? "left" : "center" }}
                jobDescription
              >
                {attributedToDescription}
              </Attribution>
            )}
          </div>
        </AttributionWrapper>
      </Wrapper>
    </PageSectionWrapper>
  );
};

export default PullQuoteSection;
